import { DEFAULT_AMPLIFY_ROUTES } from '@localstack/constants';
import { ReactElement } from 'react';
import { CreateBackendEnvironmentRequest } from '@localstack/types';
import { Breadcrumbs, ProgressButton, AmplifyBEEnvironmentForm } from '@localstack/ui';
import { useAwsEffect, useRoutes } from '@localstack/services';
import { Box, Card, CardActions, CardContent, Typography } from '@mui/material';

import { useParams } from 'react-router-dom';

import { AmplifyProps } from './types';

export const AmplifyBEEnvironmentCreate = ({
  Layout,
  clientOverrides,
  routes = DEFAULT_AMPLIFY_ROUTES,
}: AmplifyProps): ReactElement => {
  const { goto } = useRoutes();
  const { appId } = useParams<'appId'>();

  const { createBackendEnvironment, isLoading } = useAwsEffect('Amplify', ['createBackendEnvironment'], {
    clientOverrides,
    revalidate: ['listBackendEnvironments'],
  });

  const handleCreate = async (data: CreateBackendEnvironmentRequest) => {
    if (await createBackendEnvironment(data)) {
      goto(routes.RESOURCES_AMPLIFY_BE_ENVIRONMENTS, { appId });
    }
  };

  return (
    <Layout
      title={
        <Box>
          <Typography variant="h4">Environment Details</Typography>
          <Breadcrumbs
            mappings={[
              ['Amplify', () => goto(routes.RESOURCES_AMPLIFY_APPS)],
              [appId, () => goto(routes.RESOURCES_AMPLIFY_APP, { appId })],
              ['Create Environment', null],
            ]}
          />
        </Box>
      }
      actions={
        <ProgressButton
          color="primary"
          variant="outlined"
          type="submit"
          form="AmplifyBEEnvironmentCreate"
          loading={isLoading}
        >
          Submit
        </ProgressButton>
      }
    >
      <Card>
        <CardContent>
          <AmplifyBEEnvironmentForm
            formId="AmplifyBEEnvironmentCreate"
            appId={appId ?? ''}
            onSubmit={handleCreate}
            loading={isLoading}
          />
        </CardContent>
        <CardActions>
          <ProgressButton
            color="primary"
            variant="outlined"
            type="submit"
            form="AmplifyBEEnvironmentCreate"
            loading={isLoading}
          >
            Submit
          </ProgressButton>
        </CardActions>
      </Card>
    </Layout>
  );
};
